if (!window.Eurus.loadedScript.has('gift-note-checkbox.js')) {
  window.Eurus.loadedScript.add('gift-note-checkbox.js');

  (() => {
    const giftPropertyName = 'Para regalo';
    const legacyCleanupKey = 'gift-cart-attributes-cleaned';
    let isUpdating = false;

    const removeLegacyCartAttributes = async () => {
      if (sessionStorage.getItem(legacyCleanupKey)) return;

      try {
        const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Productos para regalo': null,
              '_Productos para regalo keys': null
            }
          })
        });

        if (response.ok) sessionStorage.setItem(legacyCleanupKey, 'true');
      } catch (error) {
        console.warn('Legacy gift attributes cleanup failed', error);
      }
    };

    const getMatchingCheckboxes = (key) => {
      return Array.from(document.querySelectorAll('[data-gift-note-checkbox]'))
        .filter((checkbox) => checkbox.dataset.giftNoteKey === key);
    };

    const setCheckboxState = (key, checked, disabled = false) => {
      getMatchingCheckboxes(key).forEach((checkbox) => {
        checkbox.checked = checked;
        checkbox.disabled = disabled;
      });
    };

    const updateGiftProperty = async (checkbox) => {
      if (isUpdating) {
        checkbox.checked = !checkbox.checked;
        return;
      }

      const key = checkbox.dataset.giftNoteKey;
      const previousValue = checkbox.dataset.giftPropertyValue || 'No';
      const checked = checkbox.checked;
      let updateSucceeded = false;

      if (!key) return;

      let properties;

      try {
        properties = JSON.parse(checkbox.dataset.lineProperties || '{}');

        if (Array.isArray(properties)) {
          properties = Object.fromEntries(
            properties.filter((property) => Array.isArray(property) && property.length === 2)
          );
        } else if (!properties || typeof properties !== 'object') {
          properties = {};
        }
      } catch (error) {
        properties = {};
      }

      properties[giftPropertyName] = checked ? 'Sí' : 'No';
      isUpdating = true;
      window.updatingCart = true;
      setCheckboxState(key, checked, true);

      try {
        const cartHelper = window.Alpine?.store('xCartHelper');
        const sections = cartHelper?.getSectionsToRender().map((section) => section.id) || [];
        const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: key,
            properties,
            sections,
            sections_url: window.location.pathname
          })
        });

        const cart = await response.json();

        if (!response.ok || cart.errors || cart.status) {
          throw new Error(cart.description || cart.message || 'No se pudo actualizar el producto');
        }

        if (cartHelper && cart.sections) {
          await cartHelper.reRenderSections(cart.sections);
          cartHelper.currentItemCount = cart.item_count;
        }

        updateSucceeded = true;
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      } catch (error) {
        console.warn('Gift property update failed', error);
      } finally {
        isUpdating = false;
        window.updatingCart = false;
        setCheckboxState(key, updateSucceeded ? checked : previousValue === 'Sí');
      }
    };

    document.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-gift-note-checkbox]');
      if (!checkbox) return;

      updateGiftProperty(checkbox);
    });

    removeLegacyCartAttributes();
  })();
}
